import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {FilterDataService} from "../../services/filter-data.service";
import {GeneralRequestModel} from "../../models/generalRequestModel";
import {QuizDataModel} from "../../models/quizDataModel";
import {QuizCategory} from "../../models/quiz-category";
import {ResultService} from "../../services/result.service";
import {ResultModel} from "../../models/resultModel";
import {QuizService} from "../../services/quiz.service";
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-results-database-filter',
  templateUrl: './results-database-filter.component.html',
  styleUrls: ['./results-database-filter.component.css']
})
export class ResultsDatabaseFilterComponent implements OnInit {
  isMobile: boolean = false;
  isMobileMenuClose: boolean = false;
  results: Array<ResultModel> = [];
  showFilter: boolean = false;
  quizCategories: Array<QuizCategory> = [];
  quizzes: Array<QuizDataModel> = [];
  selectedQuizId!: string;
  selectedTestCategoryId!: string;
  quizFilterDropdownSize: number = 1;
  quizCategoryDropdownSize: number = 1;
  paginationModel: GeneralRequestModel = {page: 1, count: 10, sortDirection: 'desc'};
  sortField: string = 'endTime';
  currentUserId!: string | null;

  @ViewChild('windowRef') windowRef?: ElementRef;
  @ViewChild('filterIcon') filterIcon?: ElementRef;
  @ViewChild('filterContainer') filterContainer?: ElementRef;

  constructor(
    private readonly filterDataService: FilterDataService,
    private readonly resultService: ResultService,
    private readonly quizService: QuizService,
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {
    this.currentUserId = this.authService.getCurrentUserId();
  }

  setSizeForQuizDropdown() {
    this.quizFilterDropdownSize = Math.min(this.paginationModel.count, this.quizzes.length);
  }

  ngOnInit() {
    this.resultService.updatedEvent.subscribe({
      next: () => {
        this.paginationModel = {page: 1, count: 10};
      }
    });
    this.handleScreenSizeChange();
    this.filterDataService.setFilterData(true);
    this.initializeCategories();
    this.initializeQuizzes();
  }

  onFilter(categoryId: string, quizId: string): void {
    this.navigateToResultsDatabase(categoryId, quizId);
    this.filterDataService.setFilterData(false);
  }

  resetQuizDropdownSize(dropDownSize: number): void {
    this.quizFilterDropdownSize = dropDownSize;
  }

  isQuizSelected(quizId: string): boolean {
    return quizId === this.selectedQuizId;
  }

  resetFilter() {
    this.navigateToResultsDatabase('', '');
  }

  setSizeForCategoryDropdown() {
    this.quizCategoryDropdownSize = Math.min(this.paginationModel.count, this.quizCategories.length);
  }

  @HostListener('document:click', ['$event'])
  handleClickOutsideForm(event: Event): void {
    if (this.showFilter && !this.windowRef?.nativeElement.contains(event.target)
      && !this.filterIcon?.nativeElement.contains(event.target) &&
      !this.filterContainer?.nativeElement.contains(event.target)) {
      this.showFilter = false;
    }
  }

  @HostListener('window:resize')
  onResize() {
    const screenWidth = window.innerWidth;
    this.isMobile = screenWidth < 1221;
  }

  private navigateToResultsDatabase(categoryId: string, quizId: string): void {
    this.router.navigate(['results-database'], {
      queryParams: {
        categoryId: categoryId,
        quizId: quizId,
      }
    }).then();
  }

  private initializeCategories(): void {
    if (this.currentUserId) {
      this.resultService.getAllCategoriesByAdminId(this.currentUserId)
        .subscribe({
          next: categories => {
            this.quizCategories = categories;
          }
        })
    }
  }

  private initializeQuizzes(): void {
    this.quizService.getAllForSelectFilter(this.currentUserId).subscribe({
      next: (quizzes: Array<QuizDataModel>) => {
        this.quizzes = quizzes;
      }
    })
  }

  private handleScreenSizeChange(): void {
    const screenWidth = window.innerWidth;
    if (screenWidth < 1221) {
      this.isMobile = true;
      this.isMobileMenuClose = true;
    } else if (screenWidth > 1221) {
      this.isMobile = false;
    }
  }

  protected readonly Math = Math;
}
